// Miky Motorsport - ekonomika: odmeny CR/XP, driver level (M3)
import { medalForPosition } from './career.js';

// Kredity za umisteni v zavode (vyvazeno pro ~10-15 h progrese s rozsirenym obsahem +
// mirnejsi upgrade krivkou; odmeny lehce zvysene aby vyhry byly stastne, ne grind).
const CREDITS_BY_POS = [3000, 2200, 1650, 1250, 980, 780, 620, 500];
// XP za umisteni
const XP_BY_POS = [320, 255, 200, 165, 138, 116, 100, 85];
const FINISH_BONUS = 150;

export function raceReward(position, opts = {}) {
  const i = Math.max(0, position - 1);
  let credits = CREDITS_BY_POS[Math.min(i, CREDITS_BY_POS.length - 1)] || 150;
  let xp = XP_BY_POS[Math.min(i, XP_BY_POS.length - 1)] || 60;
  // bonus za vypnute asistenty (M6) - zatim placeholder
  if (opts.assistBonus) {
    credits = Math.round(credits * (1 + opts.assistBonus));
    xp = Math.round(xp * (1 + opts.assistBonus));
  }
  // bonus za dokonceni (ne DNF)
  if (opts.finished) credits += FINISH_BONUS;
  // nasobitel z eventu kariery (obtiznost x event reward)
  if (opts.mul && opts.mul > 0) {
    credits = Math.round(credits * opts.mul);
    xp = Math.round(xp * opts.mul);
  }
  return { credits, xp };
}

// Pocet vypnutych jezdcovych asistentu (0-3) z objektu nastaveni {abs,tcs,stability}.
// Kazdy chybejici/false asistent se pocita jako vypnuty. Sdileno mezi endRace (bonus
// za odvahu) a nastavenim (zobrazeni bonusu) - drive duplikovany scitajici vyraz.
export function assistsOffCount(assists) {
  const a = assists || {};
  return (a.abs ? 0 : 1) + (a.tcs ? 0 : 1) + (a.stability ? 0 : 1);
}

// Slozeni finalni odmeny + medaile po zavode - cista verze logiky z game.js endRace.
//   position   = vysledna pozice hrace (1-based)
//   finished   = dojel hrac (ne DNF)?
//   event      = event kariery {reward,...} nebo null (rychly zavod)
//   difficulty = obtiznost {reward,...} nebo null
//   assistsOff = pocet vypnutych asistentu (0-3); bonus 0.08 za kazdy
// Vraci { credits, xp, mul, medal }. Nasobitel `mul` = event.reward x difficulty.reward
// (poradi jako v endRace), pri rychlem zavodu (event=null) je 1. Medaile jen pro event.
export function composeRaceResult(position, finished, event, difficulty, assistsOff = 0) {
  const mul = event ? (event.reward || 1) * (difficulty ? difficulty.reward : 1) : 1;
  const assistBonus = assistsOff * 0.08;
  const reward = raceReward(position, { finished, mul, assistBonus });
  const medal = event ? medalForPosition(position) : null;
  return { credits: reward.credits, xp: reward.xp, mul, medal };
}

// O kolik se zvysi stats.races za jeden odjety zavod. KONZISTENTNI pravidlo napric vsemi
// rezimy (kariera i Time Trial / denni vyzva): pocita se KAZDY odjety zavod, i kdyz hrac
// nedojel (DNF). Drive kariera pocitala vzdy, ale TT/denni jen pri dokonceni - counter pak
// znamenal v kazdem rezimu neco jineho (F-105). 1 = zavod se zucastnil.
export function racesEnteredDelta() {
  return 1;
}

// Driver level z celkoveho XP (kumulativni)
export function levelFromXp(xp) {
  // level n vyzaduje kumulativne 800 * n*(n+1)/2 ... zjednoduseno prahy
  let level = 1;
  let need = 600;
  let acc = 0;
  while (xp >= acc + need) {
    acc += need;
    level++;
    need = Math.round(need * 1.35);
  }
  return { level, intoLevel: xp - acc, forNext: need };
}

export const RANKS = [
  'Ucen', 'Zacatecnik', 'Ridic', 'Zavodnik', 'Pretendent', 'Profik',
  'Es', 'Mistr', 'Sampion', 'Legenda Miky',
];

export function rankName(level) {
  return RANKS[Math.min(level - 1, RANKS.length - 1)] || RANKS[RANKS.length - 1];
}
